import React from "react";

export const BestCommentSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 60 60"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M47 51.62a21.1 21.1 0 01-4.35 2.89A51.424 51.424 0 0130 59a51.424 51.424 0 01-12.65-4.49A21.1 21.1 0 0113 51.62L5 32V11.3a1.994 1.994 0 011.9-1.995 37.936 37.936 0 0021.837-7.86 2.016 2.016 0 012.526 0A37.936 37.936 0 0053.1 9.305 1.994 1.994 0 0155 11.3V32z"
                fill="#c03a2b"
            />
            <path
                d="M46.794 46a16.505 16.505 0 01-5.929 4.93A48.173 48.173 0 0130 54.911a48.186 48.186 0 01-10.862-3.979A16.525 16.525 0 0113.205 46L9 32V13.173a42.4 42.4 0 0021-7.665 42.4 42.4 0 0021 7.665V32z"
                fill="#e64c3c"
            />
            <path
                d="M11 56H1l3-5-3-5h12v8a2 2 0 01-2 2zM49 56h10l-3-5 3-5H47v8a2 2 0 002 2z"
                fill="#e57e25"
            />
            <rect fill="#f0c419" height={14} rx={2} width={54} x={3} y={32} />
            <g fill="#ecf0f1">
                <path d="M26.5 35a3.779 3.779 0 00-3.5 4 3.779 3.779 0 003.5 4 3.779 3.779 0 003.5-4 3.779 3.779 0 00-3.5-4zm0 6c-.813 0-1.5-.916-1.5-2s.687-2 1.5-2 1.5.916 1.5 2-.687 2-1.5 2zM9.93 37a1.886 1.886 0 011.355.579 1 1 0 101.43-1.4A3.864 3.864 0 009.93 35a4 4 0 000 8 3.864 3.864 0 002.785-1.181 1 1 0 10-1.43-1.4A1.886 1.886 0 019.93 41a2 2 0 010-4zM42.93 37a1.886 1.886 0 011.355.579 1 1 0 001.43-1.4A3.864 3.864 0 0042.93 35a4 4 0 000 8 3.864 3.864 0 002.785-1.181 1 1 0 00-1.43-1.4A1.886 1.886 0 0142.93 41a2 2 0 010-4zM20 35a1 1 0 00-1 1v2h-2v-2a1 1 0 00-2 0v6a1 1 0 002 0v-2h2v2a1 1 0 002 0v-6a1 1 0 00-1-1zM53 41h-3v-1h1a1 1 0 000-2h-1v-1h3a1 1 0 000-2h-4a1 1 0 00-1 1v6a1 1 0 001 1h4a1 1 0 000-2zM37 37a1 1 0 000-2h-4a1 1 0 000 2h1v4h-1a1 1 0 000 2h4a1 1 0 000-2h-1v-4zM29 21a1 1 0 000-2h-4a1 1 0 00-1 1v8a1 1 0 001 1h4a1 1 0 000-2h-3v-2h1a1 1 0 000-2h-1v-2zM43 19h-4a1 1 0 000 2h1v7a1 1 0 002 0v-7h1a1 1 0 000-2zM19 19h-2a1 1 0 00-1 1v8a1 1 0 001 1h2a2.987 2.987 0 002.22-5A2.987 2.987 0 0019 19zm-1 2h1a1 1 0 010 2h-1zm1 6h-1v-2h1a1 1 0 010 2zM34 23a1 1 0 11.877-1.481 1 1 0 001.752-.965A3 3 0 1034 25a1 1 0 11-.863 1.506 1 1 0 10-1.722 1.016A3 3 0 1034 23z" />
            </g>
            <path
                d="M13 54a2.006 2.006 0 01-2 2H1l3-5-3-5h4zM56 51l3 5H49a2.006 2.006 0 01-2-2l8-8h4z"
                fill="#f29c1f"
            />
        </svg>
    )
}